<template>
    <v-card class="mx-auto mb-2"
            max-width="350"
            flat
            :product="product">


        <v-list-item two-line>
            <v-list-item-avatar
                tile
                size="80"
                color="grey">
                <v-img :src="product.images[0]"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="text-h6 mb-1"
                                   :title="product.title">
                    {{ product.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ product.reference }}
                    <v-btn small icon color="indigo lighten-2"
                           link
                           target="_blank"
                           :href=getImparfaiteLinkToProduct(product.woo_commerce_product_id)
                    >
                        <v-icon small >mdi-open-in-new</v-icon>
                    </v-btn>
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip left
                       v-if="product.in_imparfaite_warehouse">
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs"
                            v-on="on"
                            left color="red accent-3">mdi-warehouse</v-icon>
                </template>
                {{ $t('products.in_imparfaite_warehouse') }}
            </v-tooltip>
        </v-card-actions>
    </v-card>

</template>

<script>
    export default {
        name: 'ProductListDetail.vue',
        props: ['product'],
        methods:{
            getImparfaiteLinkToProduct(wooCommerceProductId) {
                return 'https://www.imparfaiteparis.com/?post_type=product&p=' + wooCommerceProductId;
            },
        }
    }
</script>

<style scoped>
</style>
